import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import RenderButtons from '../general/RenderButtons'
import './MfGridComponent.css'

const ProtectedRouteNew = props => {
  const [granted, setGranted] = useState(false)
  let protectRoute = props.protected_route
  if (protectRoute) {
    protectRoute = props.protected_route.replace(/:\//g, ':')
  }

  useEffect(adminPermissions => {
    if (adminPermissions === 'false') {
      adminPermissions = false
    }
    if (props.permissions && adminPermissions) {
      const match = adminPermissions.filter(permission => props.permissions.indexOf(permission) !== -1)
      if (match.length > 0) {
        setGranted(true)
      }
    }
  }, [])

  const handleClick = e => {
    if (props.onClick) {
      props.onClick(e)
    } else if (props.protected_route) {
      const protectedRouteWithState = {
        pathname: protectRoute,
        state: props.state
      }
      props.history.push(protectedRouteWithState)
    }
  }

  const renderButton = adminPermissions => {
    let isLink = false
    if (props.protected_route && props.protected_route.includes('undefined')) {
      isLink = false
      protectRoute = null
    } else if (props.protected_route && protectRoute) {
      isLink = true
    }
    if (granted || !adminPermissions) {
      // adminPermissions = false means it's superadmin
      if (props.onButtonRender) {
        props.onButtonRender({
          disabled: props.disabled,
          icon: props.icon,
          id: props.id,
          isLink,
          name: props.name,
          protectRoute
        })
      }

      return (
        <RenderButtons
          disabled={props.disabled}
          height={props.height}
          icon={props.icon}
          isLink={isLink}
          onClick={handleClick}
          onItemClick={props.onItemClick}
          protected_route={protectRoute}
          stylingMode={props.stylingMode}
          text={props.text}
          type={props.type}
          width={props.width}
        />
      )
    }
    return null
  }
  return renderButton()
}
export default withRouter(ProtectedRouteNew)
